import classNames from 'classnames';

import { useTheme, useThemeClassName } from '../../contexts/ThemeContext';
import Accordions from '../partials/Accordions';

import styles from '../../../styles/blocks/accordions.module.scss';

interface AccordionsBlockProps {
    items: AccordionItem[] | null;
    icon?: string;
    collapsable?: boolean;
    className?: string | null;
    isContainer?: boolean;
    containerClassName?: string | null;
}

function AccordionsBlock({
    items = null,
    icon = null,
    collapsable = true,
    className = null,
    isContainer = false,
    containerClassName = null,
}: AccordionsBlockProps) {
    const { name: themeName } = useTheme();
    const themeClassName = useThemeClassName(styles);
    const withoutCollapse =
        !collapsable || themeName === 'nhl' || themeName === 'coorslive' || themeName === 'voisin';
    return (
        <div className={classNames([styles.container, className])}>
            <div
                className={classNames([
                    'block-accordions',
                    styles.inner,
                    themeClassName,
                    {
                        [styles.isContainer]: isContainer,
                        [containerClassName as string]: isContainer && containerClassName !== null,
                    },
                ])}
            >
                <Accordions
                    withoutCollapse={withoutCollapse}
                    items={items}
                    icon={icon || 'plus'}
                    itemClassName={styles.item}
                    itemInnerClassName={styles.itemInner}
                    itemLabelClassName={styles.itemLabel}
                />
            </div>
        </div>
    );
}

export default AccordionsBlock;
